<div class="alerts-title">
    <h3>{{ 'Alerts.Title' | translate }}</h3>
    <button mat-icon-button (click)="openCreateDialog()">
        <mat-icon [matTooltip]="'Alerts.DialogTitleCreate' | translate">notification_add</mat-icon>
    </button>
</div>

<div class="table-container">
    <table mat-table [dataSource]="alerts">
        <ng-container matColumnDef="alertType">
            <th mat-header-cell *matHeaderCellDef>{{ 'Alerts.AlertType' | translate }}</th>
            <td mat-cell *matCellDef="let item">{{ getAlertTypeDisplayName(item.alertType) }}</td>
        </ng-container>
        <ng-container matColumnDef="customMessage">
            <th mat-header-cell *matHeaderCellDef>{{ 'Alerts.CustomMessage' | translate }}</th>
            <td mat-cell *matCellDef="let item">{{ item.customMessage }}</td>
        </ng-container>
        <ng-container matColumnDef="editBtn">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let item">
                <button mat-icon-button (click)="openEditDialog(item)">
                    <mat-icon>edit</mat-icon>
                </button>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <tr *matNoDataRow>
            <td [attr.colSpan]="displayedColumns.length">
                {{ 'Alerts.NoAlerts' | translate }}
            </td>
        </tr>
    </table>

    @if (isLoading) {
        <div class="loading">
            <mat-spinner [diameter]="48" />
        </div>
    }
</div>
